/**
 * Redux slice names - defined centrally to ensure consistency
 * across slices and middleware.
 */
export const SLICE_NAMES = {
  APP_DATA: 'appData',
  USER: 'user',
  EXTENSION_INFO: 'extensionInfo',
  GROUPS: 'groups',
  PASSWORD_PROTECTION: 'passwordProtection',
  CUSTOMIZED_BLOCK_PAGE: 'customizedBlockPage',
  CHECKOUT_MODAL: 'checkoutModal',
  FLAGS_CONFIG: 'flagsConfig',
  WEB_HISTORY: 'webHistory',
  OMNI_SETUP: 'omniSetup',
  POPUP_MESSAGE: 'popupMessage',
  ONBOARDING: 'onboarding',
  REDIRECT: 'redirect',
  WHITELIST: 'whitelist',
  RECONSENT: 'reconsent',
  UNSAVED_CHANGES: 'unsavedChanges',
  AUTH_DISCLAIMER: 'authDisclaimer',
} as const;

/**
 * Slices that should be synced across browser tabs.
 * Only user data-related slices, not UI state.
 */
export const CROSS_TAB_SYNCED_SLICES = [
  SLICE_NAMES.USER,
  SLICE_NAMES.GROUPS,
  SLICE_NAMES.PASSWORD_PROTECTION,
  SLICE_NAMES.CUSTOMIZED_BLOCK_PAGE,
  SLICE_NAMES.FLAGS_CONFIG,
  SLICE_NAMES.REDIRECT,
  SLICE_NAMES.WHITELIST,
] as const;

export type SliceName = (typeof SLICE_NAMES)[keyof typeof SLICE_NAMES];
export type CrossTabSyncedSlice = (typeof CROSS_TAB_SYNCED_SLICES)[number];
